<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="container-fluid">
                    <form id="FormBancoImagenProducto" role="form" method="post" autocomplete="off" onSubmit="return false">
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <label for="">Nombre del Producto</label>
                                <input disabled type="text" class="form-control" placeholder="Agregar Producto" v-model="objBancoImagenProducto.Nombre">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <label for="">Costo</label>
                                <input disabled type="text" class="form-control" placeholder="Agregar Costo" v-model="objBancoImagenProducto.Costo">
                            </div>

                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <label for="">Cantidad</label>
                                <input type="text" class="form-control" placeholder="Agregar Cantidad" v-model="objBancoImagenProducto.Cantidad" @input="$onlyNums($event,objBancoImagenProducto,'Cantidad');Calcular(objBancoImagenProducto);">
                                <CValidation v-if="this.errorvalidacion.Cantidad" :Mensaje="'*'+errorvalidacion.Cantidad[0]"/>
                            </div>
                            
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <label for="">Precio Total</label>
                                <input disabled type="text" class="form-control" placeholder="Agregar Precio Total" v-model="objBancoImagenProducto.PrecioTotal">
                            </div>
                        </div>
                    </form>
                </div>
            </template>
        </CLoader>
    </div>
</template>
<script>
export default {
    name:'',
    props:['poBtnSave'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objBancoImagenProducto:{
                IdBancoImagenxProducto:0,
                Nombre:'',
                Costo:0,
                Cantidad:0,
                PrecioTotal:0
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
        }
    },
    methods: {
        async Guardar()
        {
            this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

            this.$http.put('bancoImagenProductos/'+this.objBancoImagenProducto.IdBancoImagenxProducto,
            this.objBancoImagenProducto).then((res) => {
                this.EjecutaConExito(res);
            }).catch((err) => {
                this.EjecutaConError(err);
            });
        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err){
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar()
        {
            this.$http.get('bancoImagenProductos/'+this.objBancoImagenProducto.IdBancoImagenxProducto
            ).then((res)=>{
                this.objBancoImagenProducto = res.data.data;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        Limpiar()
        {
            this.objBancoImagenProducto={
                IdBancoImagenxProducto:0,
                Nombre:'',
                Costo:0,
                Cantidad:0,
                PrecioTotal:0
            }
        },
        Calcular(item)
        {
            let Total=(isNaN(item.Cantidad)) ? 0 : parseFloat(item.Costo*item.Cantidad).toFixed(2);
            this.objBancoImagenProducto.PrecioTotal=Total;
        }
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });

            this.Limpiar();
            
            if (Id!='') 
            {
                this.objBancoImagenProducto.IdBancoImagenxProducto = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    },
}
</script>